import React from "react";
import cn from "classnames";
import styles from "./Quality.module.sass";

const Condition = () => {
  return (
    <div className={cn("section-bg", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          <h1 className={styles.title}>Conditions Générales d'Utilisation</h1>
          
          <div className={styles.summary}>
            <h2>Sommaire</h2>
            <ol>
              <li><a href="#mentions-legales">Mentions légales</a></li>
              <li><a href="#acces-plateforme">Accès à la plateforme</a></li>
              <li><a href="#services-proposes">Services proposés</a></li>
              <li><a href="#collecte-donnees">Collecte des données</a></li>
              <li><a href="#propriete-intellectuelle">Propriété intellectuelle</a></li>
              <li><a href="#responsabilite">Responsabilité</a></li>
              <li><a href="#liens-hypertextes">Liens hypertextes</a></li>
              <li><a href="#cookies">Cookies</a></li>
              <li><a href="#droit-applicable">Droit applicable et juridiction compétente</a></li>
            </ol>
          </div>

          <section id="mentions-legales" className={styles.section}>
            <h3>1. Mentions légales</h3>
            <p>
              La consultation de la plateforme Edutio ainsi que son utilisation sont subordonnées à l'acceptation 
              de nos Conditions Générales d'Utilisation.
            </p>
            <p>
              La plateforme Edutio est la propriété de [VOTRE SOCIÉTÉ], [FORME JURIDIQUE] au capital social de [MONTANT] €, 
              immatriculée au RCS de [VILLE] : [NUMÉRO RCS].
            </p>
            <p>
              Siège social : [ADRESSE COMPLÈTE]<br/>
              Email : contact@edutio.fr<br/>
              Directeur de la publication : [NOM DU DIRECTEUR]
            </p>
            <p>
              La plateforme et ses données sont conservées et stockées sur des serveurs sécurisés pendant toute 
              la durée des traitements.
            </p>
          </section>

          <section id="acces-plateforme" className={styles.section}>
            <h3>2. Accès à la plateforme</h3>
            <p>
              L'utilisateur accède aux services Edutio en s'inscrivant sur la plateforme. La plateforme est destinée 
              aux établissements de formation, CFA, organismes de formation et leurs collaborateurs.
            </p>
            <p>
              Les utilisateurs déclarent être juridiquement capables de souscrire aux services proposés par Edutio 
              et disposer des autorisations nécessaires pour représenter leur établissement.
            </p>
            <p>
              L'accès à la plateforme peut être restreint à l'égard de certaines personnes ou pays conformément 
              à la législation spécifique du pays en question.
            </p>
            <p>
              Les identifiants de connexion sont strictement personnels à l'utilisateur. Ils doivent correspondre 
              à des critères de sécurité déterminés par Edutio et ne doivent jamais être communiqués à des tiers.
            </p>
            <p>
              L'utilisateur s'engage à fournir des informations exactes, complètes, à jour et sincères tout au long 
              de sa relation avec Edutio. En cas de changement de situation, l'utilisateur s'engage à modifier 
              les informations sur son compte.
            </p>
          </section>

          <section id="services-proposes" className={styles.section}>
            <h3>3. Services proposés</h3>
            <p>
              Edutio propose une solution complète de gestion pour les centres de formation d'apprentis (CFA) 
              et organismes de formation, incluant notamment :
            </p>
            <ul>
              <li>Gestion des apprenants et de leur parcours de formation</li>
              <li>Suivi de l'émargement et de l'assiduité</li>
              <li>Gestion administrative et documentaire</li>
              <li>Outils de communication et de collaboration</li>
              <li>Rapports et statistiques de suivi</li>
              <li>Interface avec les systèmes d'information existants</li>
            </ul>
            <p>
              Edutio se réserve le droit de faire évoluer, modifier ou suspendre, sans préavis, la plateforme 
              pour des raisons de maintenance ou pour tout autre motif jugé nécessaire.
            </p>
          </section>

          <section id="collecte-donnees" className={styles.section}>
            <h3>4. Collecte des données</h3>
            <p>
              La plateforme assure à l'utilisateur une collecte et un traitement d'informations personnelles 
              dans le respect de la vie privée conformément au Règlement Général sur la Protection des Données (RGPD) 
              et à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés.
            </p>
            <p>
              En vertu de la loi Informatique et Libertés et du RGPD, l'utilisateur dispose d'un droit d'accès, 
              de rectification, de suppression, d'opposition, de limitation du traitement et de portabilité 
              de ses données personnelles.
            </p>
            <p>L'utilisateur peut exercer ces droits :</p>
            <ul>
              <li>Par email à l'adresse : contact@edutio.fr</li>
              <li>Par voie postale à l'adresse du siège social</li>
            </ul>
            <p>
              Les données collectées sont nécessaires au fonctionnement de la plateforme et à la fourniture 
              des services. Elles ne sont pas transmises à des tiers sans consentement explicite, 
              sauf obligation légale.
            </p>
          </section>

          <section id="propriete-intellectuelle" className={styles.section}>
            <h3>5. Propriété intellectuelle</h3>
            <p>
              Les marques, logos, signes ainsi que tous les contenus de la plateforme Edutio (textes, images, 
              vidéos, sons, logiciels...) font l'objet d'une protection par le Code de la propriété intellectuelle 
              et plus particulièrement par le droit d'auteur.
            </p>
            <p>
              La marque Edutio et tous les éléments distinctifs de la plateforme sont des marques déposées. 
              Toute représentation et/ou reproduction et/ou exploitation partielle ou totale de ces marques, 
              de quelque nature que ce soit, est totalement prohibée sans autorisation écrite préalable.
            </p>
            <p>
              L'utilisateur doit solliciter l'autorisation préalable d'Edutio pour toute reproduction, publication, 
              copie des différents contenus. Il s'engage à une utilisation des contenus de la plateforme dans 
              le cadre strict de l'utilisation des services, toute utilisation à des fins commerciales tierces 
              est strictement interdite.
            </p>
          </section>

          <section id="responsabilite" className={styles.section}>
            <h3>6. Responsabilité</h3>
            <p>
              Les informations diffusées sur la plateforme Edutio sont réputées fiables mais Edutio ne garantit pas 
              qu'elle soit exempte de défauts, d'erreurs ou d'omissions.
            </p>
            <p>
              Malgré des mises à jour régulières, Edutio ne peut être tenu responsable de la modification 
              des dispositions administratives et juridiques survenant après leur publication sur la plateforme.
            </p>
            <p>
              Edutio ne peut être tenu pour responsable d'éventuels virus qui pourraient infecter l'ordinateur 
              ou tout matériel informatique de l'utilisateur, suite à une utilisation, à l'accès, 
              ou au téléchargement provenant de la plateforme.
            </p>
            <p>
              La responsabilité d'Edutio ne peut être engagée en cas de force majeure ou du fait imprévisible 
              et insurmontable d'un tiers.
            </p>
            <p>
              L'utilisateur est seul responsable de l'utilisation qu'il fait de la plateforme et des données 
              qu'il y saisit. Il s'engage à respecter les réglementations en vigueur, notamment en matière 
              de protection des données personnelles.
            </p>
          </section>

          <section id="liens-hypertextes" className={styles.section}>
            <h3>7. Liens hypertextes</h3>
            <p>
              Des liens hypertextes peuvent être présents sur la plateforme Edutio. L'utilisateur est informé 
              qu'en cliquant sur ces liens, il pourra sortir de la plateforme Edutio.
            </p>
            <p>
              Edutio n'a pas de contrôle sur les pages web externes sur lesquelles aboutissent ces liens 
              et ne saurait, en aucun cas, être responsable de leur contenu.
            </p>
          </section>

          <section id="cookies" className={styles.section}>
            <h3>8. Cookies</h3>
            <p>
              L'utilisateur est informé que lors de ses visites sur la plateforme, des cookies peuvent 
              s'installer automatiquement sur son logiciel de navigation.
            </p>
            <p>
              Les cookies sont de petits fichiers stockés temporairement sur le disque dur de l'ordinateur 
              de l'utilisateur par le navigateur et qui sont nécessaires au bon fonctionnement de la plateforme.
            </p>
            <p>
              Les cookies ne contiennent pas d'information personnelle permettant d'identifier directement 
              l'utilisateur. Un cookie contient un identifiant unique, généré aléatoirement et donc anonyme.
            </p>
            <p>
              L'information contenue dans les cookies est utilisée pour améliorer l'expérience utilisateur 
              sur la plateforme Edutio. En naviguant sur la plateforme, l'utilisateur accepte l'utilisation 
              des cookies nécessaires au fonctionnement.
            </p>
            <p>
              L'utilisateur peut configurer son navigateur pour refuser les cookies, mais certaines 
              fonctionnalités de la plateforme pourraient alors ne plus être disponibles.
            </p>
          </section>

          <section id="droit-applicable" className={styles.section}>
            <h3>9. Droit applicable et juridiction compétente</h3>
            <p>
              La législation française s'applique au présent contrat. En cas d'absence de résolution amiable 
              d'un litige né entre les parties, les tribunaux français seront seuls compétents pour en connaître.
            </p>
            <p>
              Pour toute question relative à l'application des présentes CGU, vous pouvez joindre Edutio 
              aux coordonnées inscrites dans la section "Mentions légales".
            </p>
            <p>
              Les présentes conditions générales d'utilisation peuvent être modifiées à tout moment. 
              Les utilisateurs seront informés de toute modification par email ou notification sur la plateforme.
            </p>
            <p>
              <strong>Date de dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Condition;